<template>
  <page>
    <div :load="doInit">
                  <v-expansion-panels v-model="panel" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-filter-variant</v-icon> Date Range
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.expiryDateFrom" :label="labels.expiryDateFrom" v-validate="fromDateValidation(reportForm.expiryDateTo)" :data-vv-as="labels.expiryDateFrom" data-vv-name="expiryDateFrom" :error-messages="errors.collect('expiryDateFrom')" :min="reportForm.fromDateMinDate" :max="fromDateMax()"></cal-picker>
                </v-flex>
                <v-flex xs6>
                  <cal-picker v-model="reportForm.expiryDateTo" :label="labels.expiryDateTo" v-validate="toDateValidation(reportForm.expiryDateFrom)" :data-vv-as="labels.expiryDateTo" data-vv-name="expiryDateTo" :error-messages="errors.collect('expiryDateTo')" :min="reportForm.expiryDateFrom" :max="fromDateMax()"></cal-picker>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
                            </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
                  <v-expansion-panels v-model="panel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        <div>
                          <v-icon>mdi-filter-variant</v-icon> Selection Criteria
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
      <v-card>
        <v-card-text>
          <v-form>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <!-- Billing Account No. From -->
                <v-flex xs12 sm6 md6 lg6>
                  <v-autocomplete :items="billAcctNoList" v-model="reportForm.acctFrm" :label="labels.acctFrm" item-text="label" item-value="value"
                  data-vv-name="acctFrm" :data-vv-as="labels.acctFrm" :error-messages="errors.collect('acctFrm')" v-validate="acctFrmValidation(reportForm.acctTo)"
                  @change="doAcctNoFr" clearable></v-autocomplete>
                </v-flex>
                <!-- Billing Account No. To -->
                <v-flex xs12 sm6 md6 lg6>
                  <v-autocomplete :items="billAcctNoList" v-model="reportForm.acctTo" :label="labels.acctTo" item-text="label" item-value="value"
                  data-vv-name="acctTo" :data-vv-as="labels.acctTo" :error-messages="errors.collect('acctTo')" v-validate="acctToValidation(reportForm.acctFrm)"
                  clearable></v-autocomplete>
                </v-flex>
                <!-- Policy Type -->
                <v-flex xs12 sm12 md12 lg12>
                  <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')"
                  :data-vv-as="labels.polType" data-vv-name="polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly
                  v-validate="'required'"></v-text-field>
                </v-flex>
                <!-- Scheme -->
                <v-flex xs12 sm12 md12 lg12>
                  <v-text-field readonly v-model="reportForm.scheme" :label="labels.scheme" :error-messages="errors.collect('scheme')"
                  :data-vv-as="labels.scheme" data-vv-name="scheme" append-icon="mdi-magnify" @click:append="multiSchemeList = true"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
                            </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12>
              <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
      <v-dialog v-model="multiPolTypeList" width="900px" persistent>
        <multi-pol-type-help-list :pt="reportForm.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
      </v-dialog>
      <v-dialog v-model="multiSchemeList" width="900px" persistent>
        <multi-scheme-help-list :scheme="reportForm.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
      </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        expiryDateFrom: 'Expiry Date From*',
        expiryDateTo: 'Expiry Date To*',
        acctFrm: 'Billing Account From',
        acctTo: 'Billing Account To',
        polType: 'Policy Type',
        scheme: 'Scheme',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        expiryDateFrom: undefined,
        expiryDateTo: new Date(),
        acctFrm: undefined,
        acctTo: undefined,
        polType: 'All',
        scheme: 'All',
        format: undefined,
        printRptRunTime: true
      },
      // HelpList
      multiPolTypeList: false,
      multiSchemeList: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      billAcctNoList: [],
      panel: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }

        this.getCommonDataList2('billAcctNoList')
        const apiURI = this.rptMenu.initFireFreeInsExpRpt
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doAssignPolType(Obj) {
      this.reportForm.polType = []
      this.reportForm.polType = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.reportForm.scheme = []
      this.reportForm.scheme = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.multiPolTypeList = false
      this.multiSchemeList = false
    },
    doAcctNoFr() {
      if ((this.reportForm.acctFrm !== null && this.reportForm.acctFrm !== undefined && this.reportForm.acctFrm !== '') &&
      (this.reportForm.acctTo === null || this.reportForm.acctTo === undefined || this.reportForm.acctTo === '')) {
        this.reportForm.acctTo = this.reportForm.acctFrm
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    },
    acctToValidation(acct) {
      return acct !== undefined && acct.length > 0 ? 'required' : ''
    },
    acctFrmValidation(acct) {
      return 'checkAcctFrm:' + acct
    }
  },
  created() {
    this.doInit()
    const checkAcctFrm = {
      getMessage: (field, args) => {
        if (args.length > 0) {
          return 'Must be equal to or greater than FROM value values (20048)'
        }
      },
      validate: (value, args) => {
        if (value) {
          if (args.length > 0) {
            return value <= args
          } else {
            return true
          }
        } else {
          return true
        }
      }
    }
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
    this.$validator.extend('checkAcctFrm', checkAcctFrm)
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiPolTypeHelpList,
    MultiSchemeHelpList
  }
}
</script>
